module.exports = __webpack_public_path__ + "static/media/inspire-and-get-inspired.e57ccd18.png";